// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import moment from "moment-timezone";

import { FULL_ZONE_NAMES } from "../constants/timezone";
import { InfoCircleFilled } from "@ant-design/icons";
import { Input, Popover } from "antd";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'placeholder' implicitly has an 'any' type.
function DisabledInputPopover({ placeholder, popover, inputName = "Time Zone" }) {
  if (inputName === "Time Zone") {
    moment.fn.zoneName = function () {
      const abbr = this.zoneAbbr();
      // @ts-expect-error TODO(typecheck-unify): TS7053 Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly EST: "Eastern Standard Time";
      return FULL_ZONE_NAMES[abbr] || abbr;
    };
  }

  const popoverElement = (
    <Popover
      placement="bottom"
      overlayStyle={{ maxWidth: "50%", overflowWrap: "break-word" }}
      content={popover}
    >
      <InfoCircleFilled style={{ fontSize: 18, color: "#2B96FC" }} />
    </Popover>
  );

  return (
    <div>
      <Input
        className="transparent-input-popover"
        addonBefore={inputName}
        key={placeholder}
        addonAfter={popoverElement}
        placeholder={placeholder}
        disabled
      />
    </div>
  );
}

export default DisabledInputPopover;
